export const OPSTAP_CURRICULUM_SOURCE_NAME = 'OpStap';

// Production values by default; overridable per environment (e.g. staging/test vendor
// endpoints) via .env — see .env.example.
export const OPSTAP_WEBCOMPONENT_URL = import.meta.env.VITE_OPSTAP_WEBCOMPONENT_URL
	|| 'https://opstap.katholiekonderwijs.vlaanderen/webcomponent/op-stap-selector.latest.js';
export const OPSTAP_KRC_API_URL = import.meta.env.VITE_OPSTAP_KRC_API_URL
	|| 'https://api.katholiekonderwijs.vlaanderen';
export const OPSTAP_DOCUMENT_KEY = import.meta.env.VITE_OPSTAP_DOCUMENT_KEY
	|| 'bdc19260-bd4c-46a8-8009-b2a54f381120';
export const OPSTAP_SNAPSHOT = import.meta.env.VITE_OPSTAP_SNAPSHOT || 'latest';
export const OPSTAP_ENV = import.meta.env.VITE_OPSTAP_ENV || 'PROD';
